export const shareMessageContent = (
  buttonUrl: string,
  text?: string | null,
  imageUrl?: string | null,
  buttonLabel?: string | null
) => {
  return {
    id: 'a',
    meta: {},
    type: 'json',
    content: {
      type: 'flex',
      altText: text || '招待が届きました',
      contents: {
        type: 'bubble',
        size: 'giga',
        hero: imageUrl
          ? {
              type: 'image',
              url: imageUrl,
              size: 'full',
              aspectRatio: '1:1',
              aspectMode: 'cover',
              // action: {
              //   type: 'uri',
              //   label: 'Line',
              //   uri: 'https://linecorp.com/',
              // },
            }
          : undefined,
        body: {
          type: 'box',
          layout: 'vertical',
          contents: text
            ? [
                {
                  type: 'text',
                  text: text,
                  weight: 'regular',
                  wrap: true,
                  contents: [],
                },
              ]
            : [],
        },
        footer: {
          type: 'box',
          layout: 'vertical',
          flex: 0,
          spacing: 'sm',
          margin: 'xl',
          contents: buttonLabel
            ? [
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: buttonLabel,
                    uri: buttonUrl,
                  },
                  color: '#2DE033FF',
                  height: 'md',
                  style: 'primary',
                },
              ]
            : [],
        },
      },
    },
  };
};
